import { FC, PropsWithChildren } from 'react';
import NextLink, { type LinkProps } from 'next/link';
interface CustomLinkProps extends LinkProps {
  className?: string;
  anchorClassName?: string;
  target?: string;
  /** Accessible name for an icon-only link. */
  'aria-label'?: string;
}
const Link: FC<PropsWithChildren<CustomLinkProps>> = ({
  children,
  className,
  anchorClassName,
  target,
  ...props
}) => {
  return <NextLink prefetch={false} target={target || '_self'} className={anchorClassName} {...props} data-sentry-element="NextLink" data-sentry-component="Link" data-sentry-source-file="link.tsx">
      <span className={className}>{children}</span>
    </NextLink>;
};

// TODO(components): change export format to export const link;
export default Link;